"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogSizes = exports.DialogTypes = void 0;
var DialogTypes;
(function (DialogTypes) {
    DialogTypes["CONFIRMATION"] = "confirmation";
    DialogTypes["ERROR"] = "error";
})(DialogTypes = exports.DialogTypes || (exports.DialogTypes = {}));
var DialogSizes;
(function (DialogSizes) {
    DialogSizes["SMALL"] = "sm";
    DialogSizes["MEDIUM"] = "md";
    DialogSizes["LARGE"] = "lg";
    DialogSizes["FULL_SCREEN"] = "fullscreen";
})(DialogSizes = exports.DialogSizes || (exports.DialogSizes = {}));
//# sourceMappingURL=DialogProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Dialog/DialogProps.js
// module id = 449
// module chunks = 8